
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { OnboardingFormValues } from "../OnboardingFormSchema";
import { useWizard } from "../FormWizardContext";

const SOCIAL_MEDIA_OPTIONS = [
  { label: "Twitter", value: "Twitter" },
  { label: "YouTube", value: "YouTube" },
  { label: "Telegram", value: "Telegram" },
  { label: "Other", value: "Other" },
];

export const BasicInfoStep = ({ form }: { form: UseFormReturn<OnboardingFormValues> }) => {
  const { currentStep } = useWizard();

  if (currentStep !== 1) return null;

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="creator_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 dark:text-gray-200">Creator Name</FormLabel>
            <FormControl>
              <Input 
                placeholder="Enter creator name" 
                {...field} 
                className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="social_media_type"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 dark:text-gray-200">Social Media Platform</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700">
                  <SelectValue placeholder="Select platform" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {SOCIAL_MEDIA_OPTIONS.map(option => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="social_media_handler"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 dark:text-gray-200">Social Media Handle</FormLabel>
            <FormControl>
              <Input 
                placeholder="@username" 
                {...field} 
                className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="social_media_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 dark:text-gray-200">Channel/Account Name</FormLabel>
            <FormControl>
              <Input 
                placeholder="Official account name or title"
                {...field}
                className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem>
            <FormLabel className="text-gray-700 dark:text-gray-200">Contact Email</FormLabel>
            <FormControl>
              <Input 
                type="email"
                placeholder="your.email@example.com"
                {...field}
                className="bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
